
import ProductionAPIService from '@/modules/production/services/apiService'

export default class ProductionModule {
  constructor() {
  }

  install(Vue) {
    // Services
    Vue.prototype.$apiService.productionService = new ProductionAPIService(Vue.prototype.$api, Vue.prototype.$reportingApi)
  }

  getRoutes() {
    return [
      // Production Station App View List
      {
        path: '/production/stationapps',
        name: 'ProductionStationAppList',
        component: () => import('@/modules/production/views/productionStationAppList.vue'),
        meta: {
          requiresAuth: true,
          title: 'Station Apps',
          menuLink: '/tasks',
          breadcrumbs: [
            { title: 'Home', link: '/'},
            { title: 'Task Configuration', link: '/tasks/configuration'},
          ],
        }
      },

      // Toughening Batch
      {
        path: '/production/tougheningbatches/:id',
        name: 'ProductionTougheningBatch',
        component: () => import('@/modules/production/views/tougheningBatch.vue'),
        meta: {
          requiresAuth: true,
          title: 'Toughening Batch',
          menuLink: '/tasks',
          breadcrumbs: [
            { title: 'Home', link: '/'},
            { title: 'Task Configuration', link: '/tasks/configuration'},
          ],
        }
      },

      // Production Stage
      {
        path: '/production/stages/:id',
        name: 'ProductionStage',
        component: () => import('@/modules/production/views/productionStage.vue'),
        meta: {
          requiresAuth: true,
          title: 'Production Stage',
          menuLink: '/tasks/configuration',
          breadcrumbs: [
            { title: 'Home', link: '/'},
            { title: 'Task Configuration', link: '/tasks/configuration'},
          ],
        }
      },

      // Production Station
      {
        path: '/production/stations/:id',
        name: 'ProductionStation',
        component: () => import('@/modules/production/views/productionStation.vue'),
        meta: {
          requiresAuth: true,
          title: 'Production Station',
          menuLink: '/tasks/configuration',
          breadcrumbs: [
            { title: 'Home', link: '/'},
            { title: 'Task Configuration', link: '/tasks/configuration'},
          ],
        }
      },

      // Production Item
      {
        path: '/production/items',
        name: 'ProductionPanelList',
        component: () => import('@/modules/production/views/productionPanelList.vue'),
        meta: {
          requiresAuth: true,
          title: 'Production Items',
          menuLink: '/production/stationapps',
          breadcrumbs: [
            { title: 'Home', link: '/'}
          ],
        }
      },
      {
        path: '/production/items/:id',
        name: 'ProductionPanel',
        component: () => import('@/modules/production/views/productionPanel.vue'),
        meta: {
          requiresAuth: true,
          title: 'Production Item',
          menuLink: '/production/stationapps',
          breadcrumbs: [
            { title: 'Home', link: '/'}
          ],
        }
      },

      // Configuration
      {
        path: '/production/configuration',
        name: 'ProductionConfiguration',
        component: () => import('@/modules/production/views/productionConfiguration.vue'),
        meta: {
          requiresAuth: true,
          title: 'Production Configuration',
          menuLink: '/production/configuration',
          breadcrumbs: [
            { title: 'Home', link: '/'},
          ],
        }
      },

      // Production Manager
      {
        path: '/production/manager',
        name: 'ProductionManager',
        component: () => import('@/modules/production/views/productionManager.vue'),
        meta: {
          requiresAuth: true,
          title: 'Production Manager',
          menuLink: '/production/manager',
          breadcrumbs: [
            { title: 'Home', link: '/'},
          ],
        }
      }
    ]
  }
}
